import { render, staticRenderFns } from "./GenderForm.vue?vue&type=template&id=5daeaabf&"
import script from "./GenderForm.vue?vue&type=script&lang=ts&"
export * from "./GenderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports